import { useStepsStore } from "../../stores/StepsStore";

function ShareVATInfoFragment() {

  const { iAcceptToShareVatInfo, setIAcceptToShareVatInfo } = useStepsStore();
  const handleIAccepttosharevatinfo = (event: React.ChangeEvent<HTMLInputElement>) => { setIAcceptToShareVatInfo(event.target.checked); };

  return (
    <div className='form-line checkbox-and-input no-margin'>
        <div className='input-group'>
          <label className="custom-checkbox">
            <input type="checkbox"
              checked={iAcceptToShareVatInfo}
              onChange={handleIAccepttosharevatinfo}
            />
            <span></span>
            I agree to share this form with the retailer for VAT purposes.
          </label>
        </div>
      </div>
  );
}

export default ShareVATInfoFragment;